export enum ViewTypes {
  list = 'list',
}
